let label;
let language = localStorage.getItem("languageId");
if (language === "2") {
    label = {
        test: "test",
    };
} else if (language === "1") {
    label = {
        page: {
            blog: "مقالات",
            gallery: "گالری چندرسانه‌ای",
            imageGallery: "گالری تصویر",
            videoGallery: "گالری ویدئو",
            soundGallery: "گالری صوت",
        },
        menu: {
            home: "صفحه اصلی",
            langFa: "فارسی (Fa)",
            langAr: "عربی (Ar)",
        },
        button: {
            home: "صفحه اصلی",
            back: "بازگشت",
            search: "جستجو",
            answer: "پاسخ",
        },
        form: {
            searchHolder: "جستجو ...",
            categorySearchHolder: "جستجو دسته بندی ...",
            firstName: "نام",
            lastName: "نام خانوادگی",
            fullName: "نام و نام خانوادگی",
            email: "پست الکترونیک شما",
            mobile: "تلفن همراه",
            phone: "تلفن ثابت",
            address: "آدرس پستی",
            nationalCode: "کد ملی",
        },
        caption: {
            homeBlog: "اخبار و مقالات",
            loadingTxt: "از صبر و شکیبایی شما سپاسگزاریم",
            filterByCategory: "فیلتر بر اساس دسته بندی",
            filterByGallery: "فیلتر بر اساس گالری",
            publishDate: "تاریخ انتشار",
            lastUpdate: "آخرین بروزرسانی",
            category: "دسته‌بندی",
            tags: "برچسب‌ها",
            tag: "برچسب‌",
            comments: "نظرات",
            comment: "نظر",
            sendComment: "ارسال نظر",
            answerComment: "پاسخ نظر",
            relatedBlog: "مقالات مرتبط",
            relatedBlogTxt: "آخرین مقالات و اخبار مقالات مرتبط",
            tel: "شماره تماس",
            email: "پست الکترونیک",
            address: "آدرس",
            zipCode: "کد پستی",
            followUs: "ما را در فضای مجازی دنبال کنید",
        },
        popup: {
            language: "تغییر زبان",
        },
    };
}

export default label;
